import euFlag from "~/assets/images/eu-flag.png";

interface ProductTag {
  id: string;
  label: string;
  color: "amber" | "blue" | "cyan" | "green" | "orange" | "primary" | "red";
  characteristics: string[];
  image?: string | null;
}

export const productTags: ProductTag[] = [
  {
    id: "fabrication-europe",
    image: euFlag,
    label: "Fabrication Européenne",
    color: "blue",
    characteristics: ["fabrication-europe"],
  },
  {
    id: "promo",
    label: "En promo",
    color: "red",
    characteristics: ["en-promo"],
  },
  {
    id: "new",
    label: "Nouveau !",
    color: "cyan",
    characteristics: ["nouveau"],
  },
  {
    id: "fin-de-serie",
    label: "Fin de série",
    color: "amber",
    characteristics: ["fin-de-serie"],
  },
  {
    id: "bas-carbone",
    label: "Bas carbone",
    color: "green",
    characteristics: ["certification-carbone-ppe2", "certification-carbone-cre4"],
  },
  {
    id: "offre-fabricant",
    label: "Offre fabricant",
    color: "orange",
    characteristics: ["offre-fabricant"],
  },
];
